import { ThemeEvents } from "@theme/events";

class ElektraVisibility extends HTMLElement {
  connectedCallback() {
    const section = this.closest(".shopify-section, dialog");
    if (!section) return;
    this.section = section;
    this.handler = this.handleVariantUpdate.bind(this);
    this.section.addEventListener(ThemeEvents.variantUpdate, this.handler);
  }

  disconnectedCallback() {
    if (this.section && this.handler) {
      this.section.removeEventListener(ThemeEvents.variantUpdate, this.handler);
    }
  }

  handleVariantUpdate(event) {
    const variant = event.detail && event.detail.resource;
    if (!variant) return;

    let options = variant.options;
    if (!Array.isArray(options)) {
      options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    }

    const isElektra = this.checkElektra(options);
    const mode = this.dataset.mode === "hide" ? "hide" : "show";
    const shouldBeVisible = mode === "show" ? isElektra : !isElektra;
    this.hidden = !shouldBeVisible;
  }

  checkElektra(variantOptions) {
    const productTitle = (this.dataset.productTitle || "").toLowerCase();
    const titleKeywords = this.parseKeywords(this.dataset.titleKeywords);

    for (const kw of titleKeywords) {
      if (productTitle.includes(kw)) return true;
    }

    if (!Array.isArray(variantOptions)) return false;
    const variantKeywords = this.parseKeywords(this.dataset.variantKeywords);
    const excludeKeywords = this.parseKeywords(this.dataset.excludeKeywords);

    for (const value of variantOptions) {
      const val = (value || "").toLowerCase();
      let excluded = false;
      for (const ex of excludeKeywords) {
        if (val.includes(ex)) {
          excluded = true;
          break;
        }
      }
      if (excluded) continue;
      for (const kw of variantKeywords) {
        if (val.includes(kw)) return true;
      }
    }
    return false;
  }

  parseKeywords(str) {
    return (str || "")
      .toLowerCase()
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  }
}

if (!customElements.get("elektra-visibility")) {
  customElements.define("elektra-visibility", ElektraVisibility);
}
